import './styles/InputForm.css'
import React, { useState } from 'react'
import SelectorForm from './SelectorForm';

const InputForm=({titulo,type,msgError,optionDefault,endpoint,error,attr,handleInputChange,changeOption,placeHolder,isRequired,coment,data,loading,text,setText,disabled,setValidaBtn})=>{
    
    
    
    const [inputValue, setInputValue] = useState('');
const reqField=()=>{
    return(
      <p className='reqField-V2'>
        *
      </p>
    )
  }
  
   
    return(
        <div className={'contInputFormV2'+(error?' error-cont':'')}>
            <div className='compactInputFormV2'>
                <label htmlFor='InputFormV2' className={'labelInputFormV2 '+(error?'error-input':'')} >{titulo}{(text=="" && isRequired)?reqField():''} {(coment!='')?<p className='comment'>{coment}</p>:''}</label>
                {type==='textArea'?
                <textarea style={{resize:'none'}} name={attr} disabled={disabled} placeholder={placeHolder} value={text} className={"InputFormV2 textAreaInput "+(disabled?'disabled-input':'')}   onChange={handleInputChange} />
                :type==='selector'?<SelectorForm  attr={attr} placeholder={placeHolder} opGeneral={true} txtOpGen={''}  opt_de={optionDefault} origen={'Admin'} data={data}   loading={loading}  titulo={endpoint} selectFunction={changeOption} index={0}></SelectorForm>
                :
                <input type="text"  name={attr} disabled={disabled} placeholder={placeHolder} value={text} className={"InputFormV2 "+(disabled?'disabled-input':'')+' '+(error?'error-input':'')}   onChange={handleInputChange} />
}
                
            </div>
            {error?
            <div className='msg-error-cont'>
              <img  className='icon-msg-error' src={"/iconos/info_error.png"}alt="Icono" style={{width:'20px',height:'20px',marginRight:'5px'}}/>
                <div className='tooltip-error-txt'>
                    {msgError}
                </div>
           </div>
            :''}
        </div>
    )
}

export default InputForm